import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import store from "./Services/index";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { Router } from "react-router";
import { createBrowserHistory } from "history";
const history = createBrowserHistory();

ReactDOM.render(
  <Provider store={store}>
    {/* <Router history={history}>
      <App />
    </Router> */}
    {/* <BrowserRouter>
    <App />
  </BrowserRouter> */}
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
